import React, { useState } from "react";
import axios from "axios";
import { validate } from "rut.js";

import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Typography,
  IconButton,
  Grid,
  Stack,
  Box,
  InputAdornment,
  Alert,
  Fade,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BadgeIcon from "@mui/icons-material/Badge";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";

export default function BasicModal() {
  const URI = "https://demo.datachile.site/API/web/guardar_empresa.php";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Datos empresa
  const [nombre, setNombre] = useState("");
  const [rut, setRut] = useState("");
  const [direccion, setDireccion] = useState("");

  // Datos usuario administrador
  const [usuarioNombre, setUsuarioNombre] = useState("");
  const [usuarioUsername, setUsuarioUsername] = useState("");
  const [usuarioEmail, setUsuarioEmail] = useState("");
  const [usuarioPassword, setUsuarioPassword] = useState("");

  // Logo
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  // Errores
  const [error, setError] = useState("");
  const [rutError, setRutError] = useState("");

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

    setError("");
    setRutError("");

    setNombre("");
    setRut("");
    setDireccion("");

    setUsuarioNombre("");
    setUsuarioUsername("");
    setUsuarioEmail("");
    setUsuarioPassword("");

    setLogoFile(null);
    setLogoPreview(null);
  };
  const formatearRut = (valor) => {
  // Eliminar todo excepto números y K
  let rutLimpio = valor
    .replace(/[^0-9kK]/g, "")
    .toUpperCase();

  // Máximo: 8 números + dígito verificador
  rutLimpio = rutLimpio.slice(0, 9);

  // Si no hay contenido
  if (!rutLimpio) {
    return "";
  }

  // Si solo hay un carácter, todavía no hay cuerpo
  if (rutLimpio.length === 1) {
    return rutLimpio;
  }

  // Separar cuerpo y dígito verificador
  const cuerpo = rutLimpio.slice(0, -1);
  const dv = rutLimpio.slice(-1);

  // Agregar puntos cada tres dígitos
  const cuerpoFormateado = cuerpo.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    "."
  );

  return `${cuerpoFormateado}-${dv}`;
};

  const Guardar = async (e) => {
    e.preventDefault();

    setError("");
    setRutError("");

    // Validar campos obligatorios
    if (
      !nombre.trim() ||
      !rut.trim() ||
      !direccion.trim() ||
      !usuarioNombre.trim() ||
      !usuarioUsername.trim() ||
      !usuarioEmail.trim() ||
      !usuarioPassword.trim()
    ) {
      setError("Completa todos los campos obligatorios");
      return;
    }

    // Validar solamente el RUT de la empresa
    if (!validate(rut)) {
      setRutError("RUT empresa inválido");
      return;
    }

    try {
      setLoading(true);

      // Crear FormData para enviar datos y logo
      const formData = new FormData();

      // Empresa
      formData.append("nombre", nombre.trim());
      formData.append("rut", rut.trim());
      formData.append("direccion", direccion.trim());

      // Usuario administrador
      formData.append("usuario_nombre", usuarioNombre.trim());
      formData.append(
        "usuario_username",
        usuarioUsername.trim()
      );
      formData.append("usuario_email", usuarioEmail.trim());
      formData.append("usuario_password", usuarioPassword);

      // Logo
      if (logoFile) {
        formData.append("logo", logoFile);
      }

      const response = await axios.post(URI, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Respuesta:", response.data);

      handleClose();
      window.location.reload();
    } catch (err) {
      console.error("Error al guardar:", err);

      if (err.response?.data?.mensaje) {
        setError(err.response.data.mensaje);
      } else {
        setError("Error al guardar la empresa");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* BOTÓN */}
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          borderRadius: 2,
          px: 3,
          background:
            "linear-gradient(90deg, #1976d2, #42a5f5)",
        }}
      >
        Agregar Empresa
      </Button>

      {/* MODAL */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 4,
            display: "flex",
            flexDirection: "column",
            maxHeight: "90vh",
          },
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            px: { xs: 2, md: 4 },
            py: { xs: 2, md: 3 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background:
              "linear-gradient(90deg, #1976d2, #42a5f5)",
            color: "white",
          }}
        >
          <Box>
            <Typography
              variant="h6"
              fontWeight={600}
            >
              Nueva Empresa
            </Typography>

            <Typography
              variant="body2"
              sx={{ opacity: 0.8 }}
            >
              Crea empresa + usuario administrador
            </Typography>
          </Box>

          <IconButton
            onClick={handleClose}
            sx={{ color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <form onSubmit={Guardar}>
          <DialogContent
            dividers
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              overflowY: "auto",
              flexGrow: 1,
            }}
          >
            {error && (
              <Alert
                severity="error"
                sx={{ mb: 3 }}
              >
                {error}
              </Alert>
            )}

            <Grid
              container
              spacing={4}
            >
              {/* IZQUIERDA: EMPRESA */}
              <Grid
                item
                xs={12}
                md={6}
              >
                <Stack spacing={3}>
                  <Typography fontWeight={600}>
                    Empresa
                  </Typography>

                  {/* RUT EMPRESA */}
                  <TextField
                    label="RUT Empresa"
                    fullWidth
                    required
                    value={rut}
onChange={(e) => {
  const rutFormateado = formatearRut(e.target.value);

  setRut(rutFormateado);
  setRutError("");
}}
                    error={!!rutError}
                    helperText={rutError}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BadgeIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* NOMBRE EMPRESA */}
                  <TextField
                    label="Nombre Empresa"
                    fullWidth
                    required
                    value={nombre}
                    onChange={(e) =>
                      setNombre(e.target.value)
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* DIRECCIÓN */}
                  <TextField
                    label="Dirección"
                    fullWidth
                    required
                    value={direccion}
                    onChange={(e) =>
                      setDireccion(e.target.value)
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocationOnIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* SUBIDA DE LOGO */}
                  <Stack
                    spacing={1}
                    mt={3}
                  >
                    <Typography fontWeight={600}>
                      Logo de la empresa
                    </Typography>

                    <Typography
                      variant="caption"
                      color="text.secondary"
                    >
                      Debe ser formato PNG con fondo
                      transparente.
                    </Typography>

                    <input
                      type="file"
                      accept="image/png"
                      onChange={(e) => {
                        if (
                          e.target.files &&
                          e.target.files[0]
                        ) {
                          const file =
                            e.target.files[0];

                          setLogoFile(file);

                          setLogoPreview(
                            URL.createObjectURL(file)
                          );
                        }
                      }}
                      style={{
                        marginTop: 8,
                      }}
                    />

                    {logoPreview && (
                      <Box
                        mt={1}
                        sx={{
                          display: "flex",
                          justifyContent:
                            "center",
                          alignItems:
                            "center",
                          border:
                            "1px dashed #c4c4c4",
                          borderRadius: 2,
                          p: 1,
                          width: 120,
                          height: 120,
                          mx: "auto",
                          backgroundColor:
                            "#f9f9f9",
                        }}
                      >
                        <img
                          src={logoPreview}
                          alt="Vista previa del logo"
                          style={{
                            maxWidth:
                              "100%",
                            maxHeight:
                              "100%",
                          }}
                        />
                      </Box>
                    )}
                  </Stack>
                </Stack>
              </Grid>

              {/* DERECHA: USUARIO */}
              <Grid
                item
                xs={12}
                md={6}
              >
                <Stack spacing={3}>
                  <Typography fontWeight={600}>
                    Usuario administrador
                  </Typography>

                  {/* NOMBRE */}
                  <TextField
                    label="Nombre"
                    fullWidth
                    required
                    value={usuarioNombre}
                    onChange={(e) =>
                      setUsuarioNombre(
                        e.target.value
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* NOMBRE DE USUARIO */}
                  <TextField
                    label="Nombre de usuario"
                    fullWidth
                    required
                    value={usuarioUsername}
                    onChange={(e) =>
                      setUsuarioUsername(
                        e.target.value
                      )
                    }
                    inputProps={{
                      autoCapitalize:
                        "none",
                      autoCorrect:
                        "off",
                      spellCheck:
                        "false",
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* EMAIL */}
                  <TextField
                    label="Email"
                    type="email"
                    fullWidth
                    required
                    value={usuarioEmail}
                    onChange={(e) =>
                      setUsuarioEmail(
                        e.target.value
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* CONTRASEÑA */}
                  <TextField
                    label="Contraseña"
                    type="password"
                    fullWidth
                    required
                    value={usuarioPassword}
                    onChange={(e) =>
                      setUsuarioPassword(
                        e.target.value
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
              </Grid>
            </Grid>
          </DialogContent>

          {/* BOTONES */}
          <Box
            sx={{
              px: { xs: 2, md: 4 },
              py: 2,
              display: "flex",
              gap: 2,
              justifyContent:
                "flex-end",
              borderTop:
                "1px solid #e0e0e0",
              flexShrink: 0,
              backgroundColor:
                "white",
            }}
          >
            <Button
              fullWidth={isMobile}
              onClick={handleClose}
              variant="outlined"
              disabled={loading}
              sx={{
                borderRadius: 2,
              }}
            >
              Cancelar
            </Button>

            <Button
              fullWidth={isMobile}
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                borderRadius: 2,
                px: 4,
                background:
                  "linear-gradient(90deg, #1976d2, #42a5f5)",
              }}
            >
              {loading
                ? "Guardando..."
                : "Guardar"}
            </Button>
          </Box>
        </form>
      </Dialog>
    </>
  );
}